// @flow
import * as React from 'react';
import { Box } from 'grommet';
import type { SFPDetailedRepresentation } from 'esm-web-pro/types/networks';
import OpticalSwitchPortRow from 'esm-web-pro/containers/pages/network/objects/point12/poplayer12/OpticalSwitchPortRow';
import { injectIntl, IntlShape } from 'react-intl';
import point14Messages from 'esm-web-pro/messages/points14Messages';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';


type Props = {
    SFP: SFPDetailedRepresentation,
    pointCoords: [number, number],

    intl: IntlShape,
};

const SFPContent = (props: Props) => {
    const { SFP, intl: { formatMessage }, pointCoords } = props;
    return (
        <Box
            key={SFP.uuid}
            pad={{ vertical: '20px', horizontal: 'small' }}
            height={{ min: '100%' }}
        >
            <Box pad={{ horizontal: 'small' }} key={`sfp-list-box-${SFP.id}`}>
                <LabelText>{formatMessage(point14Messages.opticalPorts)}</LabelText>
            </Box>
            {SFP.optical_switch_ports.map((port) => (
                <OpticalSwitchPortRow
                    key={port.sequence}
                    pointCoords={pointCoords}
                    port={port}
                    pad={{ top: 'xxsmall' }}
                />
            ))}
        </Box>
    );
};

export default injectIntl(SFPContent);
